import { FC } from 'react'
import { Button, Toolbar, Typography, styled } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBellOn } from '@fortawesome/pro-solid-svg-icons/faBellOn'
import { focusRingOnDark } from '@app/theme'

export type Props = {
  onUpdate?: () => void
}

const AppUpdateAlert: FC<Props> = ({ onUpdate }) => {
  return (
    <StyledToolbar aria-live='polite' role='alertdialog'>
      <FontAwesomeIcon icon={faBellOn} />
      <StyledTypography>
        Update now for a better test experience. Your progress will be unaffected.
      </StyledTypography>
      <Button
        color='inherit'
        size='small'
        variant='text'
        onClick={onUpdate}
        // a11y: the toolbar's blue[600] surface collapses the default blue focus
        // ring to ~1:1, so this button uses the white on-dark ring (SC 1.4.11).
        // Keyboard-only (:focus-visible) so mouse click doesn't leave it stuck.
        sx={{ '&:focus-visible': focusRingOnDark.shadow }}
      >
        UPDATE
      </Button>
    </StyledToolbar>
  )
}

const StyledToolbar = styled(Toolbar)(({ theme: { palette, spacing } }) => ({
  backgroundColor: palette.blue[600],
  color: palette.common.white,
  padding: spacing(3, 3, 3, 5),
  minHeight: 'auto',
}))

const StyledTypography = styled(Typography)(({ theme: { palette, spacing } }) => ({
  color: palette.common.white,
  flexGrow: 1,
  marginLeft: spacing(5),
}))

export default AppUpdateAlert
